import React, { useEffect, useMemo, useState, useContext } from "react";
import { Context } from "../../../context/UserContext";

import { useNavigateParams } from "../../../hooks/useNavigateParams";
import { MaterialReactTable } from "material-react-table";

import { ThemeProvider } from "@mui/material";
/* tema customizado*/
import tableThemeCustom from "../../form/tableThemeCustom";

/* hooks */
import useFlashMessage from "../../../hooks/useFlashMessage";

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import CustomDialog from "../../layout/CustomDialog";

import { Box, Button, IconButton, Tooltip, Checkbox } from "@mui/material";
import { Delete, Edit } from "@mui/icons-material";
import tratar from "../../../utils/retornaTratamentoURL";
import CrudsAPI from "../../../api/CRUDs";

/* util */
import { obterPermissoesUsuario } from "../../../utils/funcoes";

const Index = () => {
    const [dados, setDados] = useState([]);
    const [token] = useState(localStorage.getItem("token")) || "";
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = "/Embalagens/CreateOrEdit";
    const ul = urlParams.get("ul") || 2;
    const li = urlParams.get("li") || 18;
    const tipo = urlParams.get("tipo");
    const operacaoUUID = urlParams.get("operacao");
    const uuid = urlParams.get("uuid");
    const btnText = urlParams.get("btnText") || "Cadastrar";

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //informação para tratamento de permissões
    // const isAdmin = JSON.parse(localStorage.getItem("isAdmin"));
    const { parametro } = useContext(Context);
    /* Obtem a paginação padrão */
    useEffect(() => {
        if (parametro && parametro.paginacao) {
            setPagination({
                pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
                pageSize: JSON.parse(localStorage.pagination).pageSize || parametro.paginacao,
            });
        }
    }, [parametro]);

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    //data and fetching state
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);

    //tratar filtros se vier pela navbar
    if (localStorage.path.replace(/["]/g, "") !== window.location.pathname) {
        tratar.LimparFiltros();
        localStorage.setItem("path", JSON.stringify(window.location.pathname));
    }

    //table state
    const [columnFilterFns, setColumnFiltersMode] = useState(
        localStorage.columnFilterFns.length > 2 ? JSON.parse(localStorage.columnFilterFns) : []
    );

    const [columnFilters, setColumnFilters] = useState(
        localStorage.columnFilters.length > 2 ? JSON.parse(localStorage.columnFilters) : []
    );

    const [globalFilter, setGlobalFilter] = useState(() => {
        const storedFilter = localStorage.getItem("globalFilter");

        if (storedFilter && storedFilter !== "undefined" && storedFilter.length > 2) {
            try {
                return JSON.parse(storedFilter);
            } catch (e) {
                console.warn("Erro ao parsear globalFilter:", e);
                return ""; // valor padrão
            }
        }
        return ""; // valor padrão
    });

    const [sorting, setSorting] = useState(localStorage.sorting.length > 2 ? JSON.parse(localStorage.sorting) : []);

    const [pagination, setPagination] = useState({
        pageIndex: JSON.parse(localStorage.pagination).pageIndex || 0,
        pageSize: JSON.parse(localStorage.pagination).pageSize || 5,
    });

    const fetchData = async () => {
        if (!dados.length) {
            setIsLoading(true);
        } else {
            setIsRefetching(true);
        }

        try {
            CrudsAPI.embalagem
                .listar(
                    pagination.pageIndex * pagination.pageSize,
                    pagination.pageSize,
                    JSON.stringify(columnFilters ?? []),
                    JSON.stringify(columnFilterFns ?? []),
                    globalFilter ?? "",
                    JSON.stringify(sorting ?? [])
                )
                .then((response) => {
                    setDados(response.data.data);
                    setRowCount(response.data.meta.totalRowCount);
                });
        } catch (error) {
            setIsError(true);
            console.error(error);
            return;
        }
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
    };

    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async (row) => {
        // Verifique se há uma linha selecionada
        let msgType = "success";
        if (selectedRow) {
            try {
                const response = await CrudsAPI.embalagem.deletar(selectedRow);

                setFlashMessage(response.data.message, msgType);

                // Após a exclusão, chame a função fetchData() novamente para atualizar as unidades
                fetchData();
            } catch (error) {
                msgType = "error";
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate("/Auth", { replace: true });
        }

        //funcao para setar localStorage
        localStorage.setItem(
            "pagination",
            JSON.stringify({
                pageIndex: pagination.pageIndex,
                pageSize: pagination.pageSize,
            })
        );
        localStorage.setItem("columnFilterFns", JSON.stringify(columnFilterFns));
        localStorage.setItem("columnFilters", JSON.stringify(columnFilters));
        localStorage.setItem("globalFilter", JSON.stringify(globalFilter));
        localStorage.setItem("sorting", JSON.stringify(sorting));

        //permissões do usuario
        obterPermissoesUsuario(localStorage.getItem("pessoaId"), localStorage.getItem("empresaId"), ul, li);

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, columnFilterFns, columnFilters, globalFilter, pagination.pageIndex, pagination.pageSize, sorting, ul, li]);

    const columns = useMemo(
        () => [
            {
                id: "Embalagem",
                header: "Cadastro de EMBALAGENS da empresa",
                columns: [
                    {
                        accessorKey: "Empresa.nomeFantasia",
                        header: "Empresa",
                    },
                    {
                        accessorKey: "descricao",
                        header: "Descrição",
                    },
                    {
                        accessorKey: "Unidade.codigo",
                        header: "Código",
                    },
                    {
                        accessorKey: "fator",
                        header: "Fator",
                        muiTableBodyCellProps: {
                            align: "right",
                        },
                        accessorFn: (row) =>
                            row.fator === undefined
                                ? ""
                                : parseFloat(row.fator)?.toLocaleString("pt-BR", {
                                      style: "decimal",
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  }),
                    },
                    {
                        accessorKey: "aceitaFracao",
                        header: "Aceita Fração",
                        type: "boolean",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Sim", value: "1" },
                            { label: "Não", value: "0" },
                        ],
                        filterVariant: "select",
                        Cell: ({ row }) => {
                            const value = row.original.aceitaFracao;
                            return <div style={{ textAlign: "left" }}>{value ? "Sim" : "Não"}</div>;
                        },
                    },
                    {
                        accessorKey: "pesavel",
                        header: "Pesável",
                        type: "boolean",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Sim", value: "1" },
                            { label: "Não", value: "0" },
                        ],
                        filterVariant: "select",
                        Cell: ({ row }) => {
                            const value = row.original.pesavel;
                            return <div style={{ textAlign: "left" }}>{value ? "Sim" : "Não"}</div>;
                        },
                    },
                    {
                        accessorKey: "entrada",
                        header: "Entrada",
                        type: "boolean",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Sim", value: "1" },
                            { label: "Não", value: "0" },
                        ],
                        filterVariant: "select",
                        Cell: ({ row }) => {
                            const value = row.original.entrada;
                            return <div style={{ textAlign: "left" }}>{value ? "Sim" : "Não"}</div>;
                        },
                    },
                    {
                        accessorKey: "saida",
                        header: "Saída",
                        type: "boolean",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Sim", value: "1" },
                            { label: "Não", value: "0" },
                        ],
                        filterVariant: "select",
                        Cell: ({ row }) => {
                            const value = row.original.saida;
                            return <div style={{ textAlign: "left" }}>{value ? "Sim" : "Não"}</div>;
                        },
                    },
                    {
                        accessorKey: "industria",
                        header: "Indústria",
                        type: "boolean",
                        columnFilterModeOptions: ["equals"],
                        filterSelectOptions: [
                            { label: "Todos", value: "" },
                            { label: "Sim", value: "1" },
                            { label: "Não", value: "0" },
                        ],
                        filterVariant: "select",
                        Cell: ({ row }) => {
                            const value = row.original.industria;
                            return <div style={{ textAlign: "left" }}>{value ? "Sim" : "Não"}</div>;
                        },
                    },
                ],
            },

            //column definitions...
        ],
        [] //getCommonEditTextFieldProps
    );

    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title="Delete EMBALAGEM!"
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        "mrt-row-actions": {
                            muiTableHeadCellProps: {
                                align: "center",
                            },
                            size: 100,
                        },
                        "mrt-row-numbers": {
                            enableColumnOrdering: true, //turn on some features that are usually off
                            enableResizing: true,
                            muiTableHeadCellProps: {
                                sx: {
                                    fontSize: "1.2rem",
                                },
                            },
                        },
                        "mrt-row-select": {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    //enableColumnResizing
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                            <Tooltip arrow placement="left" title="Editar">
                                <span>
                                    {" "}
                                    <IconButton
                                        onClick={() => {
                                            params.set("uuid", row.id);
                                            params.set("btnText", "Atualizar");
                                            navigate(pathname, params);
                                        }}
                                        disabled={JSON.parse(localStorage.getItem("editar")) === false}
                                    >
                                        <Edit />
                                    </IconButton>
                                </span>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Deletar">
                                <span>
                                    <IconButton
                                        color="error"
                                        onClick={() => handleOpenDialog(row)}
                                        disabled={JSON.parse(localStorage.getItem("cancelar")) === false}
                                    >
                                        <Delete />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                            }}
                        >
                            <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                <div>
                                    {" "}
                                    <Button
                                        color="secondary"
                                        onClick={() => {
                                            params.delete("uuid");
                                            params.set("btnText", "Cadastrar");
                                            navigate(pathname, params);
                                        }}
                                        variant="contained"
                                        disabled={JSON.parse(localStorage.getItem("incluir")) === false}
                                    >
                                        Novo
                                    </Button>
                                </div>
                            </Tooltip>
                        </div>
                    )}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        isError
                            ? {
                                  color: "error",
                                  children: "Error loading data",
                              }
                            : undefined
                    }
                    onColumnFiltersChange={setColumnFilters}
                    onColumnFilterFnsChange={setColumnFiltersMode}
                    onGlobalFilterChange={setGlobalFilter}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    rowCount={rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: "compact",
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns,
                        columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    positionExpandColumn={"first"}
                    positionActionsColumn={"first"}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
